<template>
  <div class="seoService container">
    <transition name="expand">
      <report-history-list
        v-if="isReportHistoryVisible"
        :service-id="serviceId"
        :reports="reports"
        @showReportByDate="changeReportDate"
      />
    </transition>
    <Header :date="date" />
    <div class="columns">
      <div class="column column-content">
        <div class="seo-item">
          <widget-container
            widget-type="performanceScore"
            :date="date"
          />
        </div>

        <div class="seo-item">
          <widget-container
            widget-type="websitePagesIndexed"
            :date="date"
          />
        </div>
      </div>

      <div class="column column-content">
        <div class="seo-item">
          <widget-container
            widget-type="websiteAuthority"
            :date="date"
          />
        </div>

        <div class="seo-item">
          <widget-container
            widget-type="linkingWebsites"
            :date="date"
          />
        </div>

        <div class="seo-item">
          <widget-container
            widget-type="inboundLinks"
            :date="date"
          />
        </div>
      </div>
    </div>

    <hr>

    <div class="columns">
      <h1 class="google-search is-size-1 has-text-dark">
        Google Search Rankings
      </h1>
    </div>

    <div class="columns">
      <div class="column is-4 column-content">
        <div class="seo-item">
          <widget-container
            widget-type="rankingChangeAllKeywords"
            :date="date"
          />
        </div>
      </div>

      <div class="column is-8 column-content">
        <div class="seo-item">
          <widget-container
            widget-type="rankingChangeByGoogleEngine"
            :date="date"
          />
        </div>
      </div>
    </div>

    <widget-container
      widget-type="fullRankingReport"
      :date="date"
    />

    <widget-container
      widget-type="historicalRankings"
      :date="date"
    />
  </div>
</template>

<script>
import WidgetContainer from '@/components/SeoService/Widgets/WidgetContainer'
import Header from '@/components/SeoService/Header'
import ReportHistoryList from '@/components/SeoService/ReportHistoryList'
import GET_LAST_REPORT from '@/graphql/GET_LAST_REPORT.gql'
import GET_LIST_OF_REPORTS from '@/graphql/GET_LIST_OF_REPORTS.gql'

export default {
  name: 'SeoService',

  components: {
    WidgetContainer,
    Header,
    ReportHistoryList
  },

  data () {
    return {
      showHistory: false,
      date: 'last',
      serviceId: null
    }
  },

  computed: {
    isReportHistoryVisible () {
      return this.$store.state.seoService.showHistory
    }
  },

  created () {
    let { serviceId } = this.$route.params
    this.serviceId = serviceId
  },

  apollo: {
    lastReport: {
      query: GET_LAST_REPORT,
      variables () {
        return { seoId: this.serviceId }
      },
      update: data => data.getSEOReportByDate
    },
    reports: {
      query: GET_LIST_OF_REPORTS,
      variables () {
        return { seoId: this.serviceId }
      },
      update: data => data.listSEOReportHistory
    }
  },

  methods: {
    changeReportDate (date) {
      this.date = date
    }
  }

}
</script>

<style lang="scss" scoped>
@import '../../sass/_variables.scss';
.columns {
  align-items: stretch;
}
.column-content {
  padding-top: 0;
  padding-bottom: 0;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.seo-item {
  flex: 1 1 auto;
  margin-bottom: 10px;
  .card {
    height: 100%;
  }
}
.google-search {
  padding: 10px;
}

</style>
